import { useState, useEffect } from 'react';
import { toast } from 'react-hot-toast';
import { usePostTripConnect } from '../../../../context/postTripConnect/PostTripConnectContext';
import { usePlanAccess } from '../../../../components/gating/PlanGate';
import AutoNotifications from './sections/AutoNotifications/AutoNotifications';
import CustomBroadcast from './sections/CustomBroadcast/CustomBroadcast';
import SentHistory from './sections/SentHistory/SentHistory';
import { postTripData } from '../../utils/postTripHelpers';

const NotificationsTab = () => {
    const { isLocked: isNotificationsLocked } = usePlanAccess('growth');
    const {
        preferences: prefs,
        setPreferences: setPrefs,
        history,
        notificationsLoading: loading,
        fetchNotificationPreferences,
        updateNotificationPreferences,
        fetchNotificationHistory,
        sendCustomBroadcast
    } = usePostTripConnect();
    const [activeTab, setActiveTab] = useState('auto');

    // Custom send form state
    const [customForm, setCustomForm] = useState({
        title: '',
        message: '',
        target: 'all'
    });

    const tabs = postTripData.notificationTabs || [];

    useEffect(() => {
        fetchNotificationPreferences();
        fetchNotificationHistory();
    }, [fetchNotificationPreferences, fetchNotificationHistory]);

    const handleToggle = async (key) => {
        const currentPrefs = prefs || {
            welcome_back: { enabled: true },
            feedback_nudge: { enabled: true },
            new_package_published: { enabled: true },
            seasonal_greeting: { enabled: false },
            trip_anniversary: { enabled: false }
        };
        const updatedVal = !currentPrefs[key]?.enabled;
        const newPrefs = {
            ...currentPrefs,
            [key]: { enabled: updatedVal }
        };

        try {
            await updateNotificationPreferences(newPrefs);
        } catch (error) {
            fetchNotificationPreferences(); // rollback
        }
    };

    const handleSendCustom = async (e) => {
        e.preventDefault();
        if (!customForm.title || !customForm.message) {
            toast.error('Title and message are required');
            return;
        }
        
        try {
            await sendCustomBroadcast(
                customForm.title,
                customForm.message,
                customForm.target
            );
            setCustomForm({ title: '', message: '', target: 'all' });
            setActiveTab('history');
        } catch (err) {
            console.error('Error sending custom notification:', err);
        }
    };

    return (
        <div className="w-full space-y-6">
            {/* Header Tabs */}
            <div className="flex border-b border-slate-200 gap-6 animate-in fade-in duration-200">
                {tabs.map((tab) => (
                    <button
                        key={tab.id}
                        type="button"
                        onClick={() => setActiveTab(tab.id)}
                        className={`pb-3 text-sm font-bold border-b-2 cursor-pointer transition-colors ${
                            activeTab === tab.id
                                ? 'border-[#067978] text-[#067978]'
                                : 'border-transparent text-slate-500 hover:text-slate-700'
                        }`}
                    >
                        {tab.label}
                    </button>
                ))}
            </div>

            {/* SubTab 1: Auto Notifications */}
            {activeTab === 'auto' && (
                <AutoNotifications
                    prefs={prefs || {}}
                    onToggle={handleToggle}
                    loading={loading}
                    isNotificationsLocked={isNotificationsLocked}
                />
            )}

            {/* SubTab 2: Send Custom */}
            {activeTab === 'custom' && (
                <CustomBroadcast
                    customForm={customForm}
                    setCustomForm={setCustomForm}
                    onSendCustom={handleSendCustom}
                    isNotificationsLocked={isNotificationsLocked}
                />
            )}

            {/* SubTab 3: History */}
            {activeTab === 'history' && (
                <SentHistory
                    history={history}
                    loading={loading}
                    isNotificationsLocked={isNotificationsLocked}
                />
            )}
        </div>
    );
};

export default NotificationsTab;
